<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    盐田路站<br>
站点介绍<br>
盐田路站位于盐田路与东海道交口处，车站沿盐田路东北-西南向布置，西南接深外高中站。 盐田路站是8号线一期的终点站，车站定义为特色站，以海洋世界为设计主题，通过“鱼游海底”营造旅游空间氛围。车站为地下两层形式，地下一层为站厅，地下二层为站台，站台为一岛一侧式站台。车站设置有6个出入口，车站有大型物业区及后期与大型佳兆业商城无缝连接。周边成熟的配套生活区主要为金港花园、富基金港6号、麓港国际及社排新村。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	23:10	8号线	5分10秒	5分45秒<br>
盐田路	--	--	8号线	5分10秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	23:10	8号线	4分钟	5分钟<br>
盐田路	--	--	8号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	00:00	8号线	4分钟	5分钟<br>
盐田路	--	--	8号线	4分钟	5分钟<br><br>

站点出口信息<br><br>
C出入口:<br>
南方明珠幼儿园<br><br>
D出入口:<br>
东海道西侧（北）<br><br>
E出入口:<br>
盐田双拥公园、盐田路西侧（北）<br><br>
F出入口:<br>
乐群小学、明珠社区公园、东海道南侧（西）、深圳市盐田区人民医院<br><br>
G出入口:<br>
盐田路东侧（南）<br><br>
H1出入口:<br>
明珠人口文化公园、盐田人口文化大舞台、盐田街道办、盐田区图书馆（盐田分馆）、盐田青少年篮球协会、裕达幼儿园、明珠社区居委会、东海四街南侧（西）<br><br>
H2出入口:<br>
明珠人口文化公园、盐田人口文化大舞台、盐田街道办、盐田区图书馆（盐田分馆）、盐田青少年篮球协会、裕达幼儿园、明珠社区居委会、东海四街南侧（西）<br><br>
公交换乘信息<br><br>
D出入口:<br>
公交站名： 东海丽景花园<br>
205、358、68、B925、M290、M348、M380、M396、M444、M465、小梅沙假日专线1<br><br>
E出入口:<br>
公交站名： 东海丽景花园<br>
205、358、68、B925、B927、M290、M348、M380、M396、M444、M465、小梅沙假日专线1<br><br>
F出入口:<br>
公交站名： 盐田医院盐田院区<br>
205、358、68、B925、M290、M348、M380、M396、M444、M465、小梅沙假日专线1<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "bahaoxian",
          title: "8号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>